import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { queryClient } from '@/lib/react-query/queryClient';
import { coordinationEndpoints } from '@/modules/coordination/constants';
import { coordinationQueryKeys } from '@/modules/coordination/queries/queryKeys';
import type { CoordinationProcessStatusUpdateRequestApi } from '@/modules/coordination/types';

export const useUpdateCoordinationProcessStatusMutation = (
  jobId: string,
  coordinationProcessId: string,
) => {
  return useMutation({
    mutationFn: async (body: CoordinationProcessStatusUpdateRequestApi) => {
      const { data } = await fetchClient.PUT(
        coordinationEndpoints.processStatus,
        {
          params: { path: { jobId, coordinationProcessId } },
          body,
        },
      );
      return data;
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: coordinationQueryKeys.processDetail(
          jobId,
          coordinationProcessId,
        ),
      });
      queryClient.invalidateQueries({
        queryKey: coordinationQueryKeys.processes(jobId),
      });
    },
  });
};
